/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by richardwilliams on 4/3/15.
 */

'use strict';

angular
    .module('prism-ui.package')
    .controller('PackageEditController',
        function (_, $scope, $routeParams, $q, $location, $route, PackageResourceFactory, PaginationService,
                  PackageActionService, NotificationService, PackageUtilService, ModalService, PermissionsService,
                  BreadcrumbService, ContentResourceFactory, PartnerPackagesService, MetadataService, EnumService, DynamicPropertiesService) {

            var META_TAB_VIEW_STATE = 'PACKAGE_METADATA_VIEW_STATE';
            var COLLABORATORS_TAB_VIEW_STATE = 'PACKAGE_COLLABORATORS_VIEW_STATE';
            var MEDIA_TAB_VIEW_STATE = 'PACKAGE_MEDIA_VIEW_STATE';
            var TIMINGS_TAB_VIEW_STATE = 'PACKAGE_TIMINGS_VIEW_STATE';
            var DISTRIBUTION_TAB_VIEW_STATE = 'PACKAGE_DISTRIBUTIONGRID_VIEW_STATE';
            var ADVANCED_DISTRIBUTION_TAB_VIEW_STATE = 'ADVANCED_PACKAGE_DISTRIBUTIONGRID_VIEW_STATE';
            var PREVIEW_TAB_VIEW_STATE = 'PACKAGE_VIDEO_PREVIEW_VIEW_STATE';
            var CLIP_TABS_VIEW_STATE = 'PACKAGE_VIDEO_CLIPS_VIEW_STATE';
            var PACKAGE_ADVANCED_METADATA_VIEW_STATE = 'PACKAGE_ADVANCED_METADATA_VIEW_STATE';
            var PACKAGE_COMPLETED_DELIVERIES_VIEW_STATE = 'PACKAGE_COMPLETED_DELIVERIES_VIEW_STATE';
            var PACKAGE_EXTERNAL_INGESTS_VIEW_STATE = 'PACKAGE_EXTERNAL_INGESTS_VIEW_STATE';

            var originalPackageData;

            var self = this;
            self.permissionsMap = {};
            self.activeTabs = {
                metadata: false,
                collaborators: false,
                media: false,
                timings: false,
                distribution: false,
                advancedDistribution: false,
                preview: false,
                liveClip: false,
                advancedMetadata: false,
                completedDeliveries: false,
                aggregation: false,
            };
            self.currentViewedTab = '';

            self.validTabs = {
                metadata: false,
                collaborators: false,
                media: false,
                timings: false,
                distribution: false,
                advancedDistribution: false,
                preview: false,
                clips: false,
                advancedMetadata: false,
                completedDeliveries: false,
                aggregation: false,
            };
            BreadcrumbService.editService = PackageUtilService;

            var syncPackageValidation = function (packageObject) {
                return PartnerPackagesService.reviseInstanceValidationResults(
                    self.packageObjectData.id,
                    packageObject.validationResult
                ).then(function () {
                    return packageObject;
                });
            };

            var pollForPackageUpdates = function () {
                return PackageResourceFactory.get({
                    id: $routeParams.id,
                    view: 'STATUS'
                }).$promise
                    .then(function (packageData) {
                        return syncPackageValidation(packageData);
                    })
                    .then(function (packageData) {
                        self.packageObjectData.metadataErrorCount = packageData.metadataErrorCount;
                        self.packageObjectData.mediaErrorCount = packageData.mediaErrorCount;
                        self.packageObjectData.status = packageData.status;
                        self.packageObjectData.acceptStatus = packageData.acceptStatus;
                        self.packageObjectData.validationResult = packageData.validationResult;
                        self.packageObjectData.primaryVideo = packageData.primaryVideo;
                        self.packageObjectData.revision = packageData.revision;
                        self.packageObjectData.isDelivering = packageData.isDelivering;
                        self.packageObjectData.pendingPartnerPackages = packageData.pendingPartnerPackages;
                        originalPackageData.metadataErrorCount = packageData.metadataErrorCount;
                        originalPackageData.mediaErrorCount = packageData.mediaErrorCount;
                        originalPackageData.status = packageData.status;
                        originalPackageData.acceptStatus = packageData.acceptStatus;
                        originalPackageData.validationResult = packageData.validationResult;
                        originalPackageData.primaryVideo = packageData.primaryVideo;
                        originalPackageData.revision = packageData.revision;
                        originalPackageData.isDelivering = packageData.isDelivering;
                        if (self.currentViewedTab !== 'liveClip') {
                            PackageActionService.selectedPackages = [self.packageObjectData];
                            PackageActionService.handleEditView('notClip');
                        }
                    });
            };

            var showUnsavedChangesWarning = function () {
                var message = 'You have unsaved changes.  Please save or revert.';
                NotificationService.createWarningNotification(message, '');
            };

            var parseContentCategories = function (allContentCategories) {
                var categories = {};
                _.forEach(allContentCategories, function (contentCategory) {
                    categories[contentCategory.category.id] = contentCategory;
                });
                return categories;
            };

            var getEditData = function (perms) {
                $q.all([
                    DynamicPropertiesService.queryForProperties(),
                    EnumService.queryForEnums(),
                ])
                    .then(() => {
                        self.packageObjectData = PackageResourceFactory.get({id: $routeParams.id});
                        return self.packageObjectData.$promise;
                    })
                    .then(function (data) {

                        //
                        // In theory, this should never be needed.
                        // Reloading a package resets all instance
                        // selections to the newest instances, making
                        // the package's validation result accurate.
                        //

                        return syncPackageValidation(data);
                    })
                    .then(function (data) {
                        var deferred = $q.defer();
                        if (data.hidden) {
                            $location.url('/packages');
                            NotificationService.createWarningNotification('Package is Hidden');
                            deferred.reject('Package is Hidden');
                        } else {
                            originalPackageData = _.cloneDeep(data);
                            PackageUtilService.createErrorsAndWarningsMap(data.validationResult);
                            deferred.promise = ContentResourceFactory.get({id: data.content.id}).$promise;
                        }
                        return deferred.promise;
                    })
                    .then(function (content) {
                        self.categoryRoles = parseContentCategories(content.contentCategories);
                        PackageUtilService.contentCategories(self.categoryRoles);
                        // This tab needs to be set after all data is ready to prevent exceptions on data access
                        self.activeTabs[$routeParams.editView] = true;
                        self.currentViewedTab = $routeParams.editView;

                        self.validTabs.metadata = perms.meta;
                        self.validTabs.collaborators = perms.collaborators;
                        self.validTabs.media = perms.media;
                        self.validTabs.timings = perms.timings;
                        self.validTabs.distribution = perms.distribution;
                        self.validTabs.advancedDistribution = perms.advancedDistribution;
                        self.validTabs.preview = perms.preview;
                        self.validTabs.clips = perms.clips;
                        self.validTabs.advancedMetadata = perms.advancedMetadata;
                        self.validTabs.completedDeliveries = perms.completedDeliveries;
                        self.validTabs.aggregation = perms.externalIngests;

                        if (self.currentViewedTab !== 'liveClip') {
                            PackageActionService.selectedPackages = [self.packageObjectData];
                            PackageActionService.handleEditView('notClip');
                        }
                        PackageUtilService.setPollingInterval();
                    });
            };

            var getPermissions = function () {
                var metaPromise = PermissionsService.canRead(META_TAB_VIEW_STATE);
                var collaboratorPromise = PermissionsService.canRead(COLLABORATORS_TAB_VIEW_STATE);
                var mediaPromise = PermissionsService.canRead(MEDIA_TAB_VIEW_STATE);
                var timingsPromise = PermissionsService.canRead(TIMINGS_TAB_VIEW_STATE);
                var distributionPromise = PermissionsService.canRead(DISTRIBUTION_TAB_VIEW_STATE);
                var advancedDistributionPromise = PermissionsService.canRead(ADVANCED_DISTRIBUTION_TAB_VIEW_STATE);
                var previewPromise = PermissionsService.canRead(PREVIEW_TAB_VIEW_STATE);
                var clipsPromise = PermissionsService.canRead(CLIP_TABS_VIEW_STATE);
                var advancedMetadataPromise = PermissionsService.canRead(PACKAGE_ADVANCED_METADATA_VIEW_STATE);
                var completedDeliveriesPromise = PermissionsService.canRead(PACKAGE_COMPLETED_DELIVERIES_VIEW_STATE);
                var externalIngestsPromise = PermissionsService.canRead(PACKAGE_EXTERNAL_INGESTS_VIEW_STATE);

                return $q.all({
                    meta: metaPromise,
                    collaborators: collaboratorPromise,
                    media: mediaPromise,
                    timings: timingsPromise,
                    distribution: distributionPromise,
                    advancedDistribution: advancedDistributionPromise,
                    preview: previewPromise,
                    clips: clipsPromise,
                    advancedMetadata: advancedMetadataPromise,
                    completedDeliveries: completedDeliveriesPromise,
                    externalIngests: externalIngestsPromise,
                });
            };

            var hasWarnings = function () {
                for (var i = 0; i < self.packageObjectData.validationResult.length; i++) {
                    var valResult = self.packageObjectData.validationResult[i];
                    if (valResult.warnings && valResult.warnings.length > 0) {
                        return true;
                    }
                }

                return false;
            };

            self.loadingIndicator = {
                backdrop: true,
                show: false,
                title: 'Working',
                message: 'Please wait...'
            };

            self.pagingOptions = PaginationService;

            self.onSave = function (savePackageOnly) {
                self.loadingIndicator.show = true;

                // Stop polling until saving is complete
                PackageUtilService.cancelPollingInterval();

                var tabPromise = null;
                var packagePromise = null;
                var packageSaved = false;

                // Clones are no longer clones after being saved
                if (self.packageObjectData.clone) {
                    self.packageObjectData.clone = false;
                }

                // When changing package media, clear accept/reject data
                if (self.currentViewedTab === 'media' && !savePackageOnly) {
                    self.packageObjectData.acceptStatus = null;
                    self.packageObjectData.rejectReason = null;
                }

                // **************************************************************** //
                // **************************************************************** //
                // **** Seriously! Always perform this action before you save  **** //
                // **** metadata items to ensure the correct data is persisted **** //
                // **************************************************************** //
                // **************************************************************** //
                if (PackageUtilService.metadataComponentsMap) {
                    let cleanData = MetadataService.cleanData(self.packageObjectData, PackageUtilService.metadataComponentsMap);
                    self.packageObjectData = cleanData;
                }

                if ('rating' in self.packageObjectData) {
                    if (_.isEmpty(_.get(self.packageObjectData, 'rating.ratingCode'))) {
                        console.log(`ratingCode not found. Deleting rating object.`);
                        self.packageObjectData.rating = null;
                    } else {
                        console.log(`ratingCode found.`);
                    }
                }

                // Only save when modified
                if (!angular.equals(self.packageObjectData, originalPackageData)) {
                    packagePromise = self.packageObjectData.$save().then(function (packageObject) {
                        return syncPackageValidation(packageObject);
                    });
                    packageSaved = true;
                }

                // Save "specialized" tabs
                if (PackageUtilService.tabSaveFunction &&
                    !savePackageOnly &&
                    self.currentViewedTab !== 'metadata' &&
                    self.currentViewedTab !== 'media') {
                    tabPromise = PackageUtilService.tabSaveFunction(packageSaved);
                }

                // Saves on any package tab can potentially change the
                // validation result
                var validationPromise;
                if (!packagePromise) {
                    validationPromise = PackageResourceFactory.query({
                        id: $routeParams.id,
                        sub: 'validationResult',
                    }).$promise.then(function (validationResult) {
                        self.packageObjectData.validationResult = validationResult;
                        return syncPackageValidation(self.packageObjectData);
                    });
                } else {
                    validationPromise = $q.when(true);
                }

                return $q.all({
                    package: packagePromise,
                    tabData: tabPromise,
                    validationResult: validationPromise,
                })
                    .then(function (results) {
                        if (results.package) {
                            originalPackageData = _.cloneDeep(results.package);
                            self.packageObjectData = results.package;

                            PackageActionService.selectedPackages = [
                                self.packageObjectData
                            ];
                            PackageActionService.handleEditView('notClip');
                        }

                        if (PackageUtilService.postPackageSaveFunction && results.package) {
                            PackageUtilService.postPackageSaveFunction();
                        }

                        if (PackageUtilService.setPristinePostSave) {
                            PackageUtilService.editorForm.$setPristine();
                        }

                        // Restart polling interval
                        PackageUtilService.setPollingInterval();

                        self.loadingIndicator.show = false;

                        // ABC-8573 - https://levelsbeyond.atlassian.net/browse/ABC-8573
                        // Until a refactor of the package edit can be performed, ensure all package data is first
                        // saved to prevent assets from being purged on ingest unintentionally.
                        if (PackageUtilService.tabSaveFunction && !savePackageOnly && self.currentViewedTab === 'media') {
                            PackageUtilService.tabSaveFunction();
                        }
                    });
            };

            PackageUtilService.tabLoadDataFunction = function () {
                getPermissions();
            };

            self.onNew = function () {
                if (PackageUtilService.tabNewFunction) {
                    PackageUtilService.tabNewFunction();
                }
            };

            self.onDelete = function () {
                if (PackageUtilService.tabDeleteFunction) {
                    PackageUtilService.tabDeleteFunction();
                }
            };

            self.onAddDisabled = function () {
                if (PackageUtilService.tabAddDisabledFunction) {
                    PackageUtilService.tabAddDisabledFunction();
                }
            };

            self.onRevert = function () {
                self.packageObjectData = _.cloneDeep(originalPackageData);
                if (PackageUtilService.tabRevertFunction) {
                    PackageUtilService.tabRevertFunction(self.packageObjectData);
                }
                PackageUtilService.editorForm.$setPristine();
            };

            self.onClose = function () {
                if (PackageUtilService.editorForm.$pristine) {
                    PartnerPackagesService.clearInstanceSelections();
                    BreadcrumbService.clearBreadcrumbs();
                    $location.path('/packages');
                    $location.search('pmView', 'basic');
                } else {
                    showUnsavedChangesWarning();
                }
            };

            self.onUpload = function () {
                if (PackageUtilService.tabUploadFunction) {
                    PackageUtilService.tabUploadFunction();
                }
            };

            self.onPrevPackage = function () {
                PaginationService.getPreviousItemInPage().then(function (packageData) {
                    PartnerPackagesService.clearInstanceSelections();
                    $route.updateParams({id: packageData.id});
                });
            };

            self.onNextPackage = function () {
                PaginationService.getNextItemInPage().then(function (packageData) {
                    PartnerPackagesService.clearInstanceSelections();
                    $route.updateParams({id: packageData.id});
                });
            };

            self.onTabSelect = function (tabName) {
                if (_.get(PackageUtilService, 'editorForm.$pristine')) {
                    if (tabName === 'metadata') {
                        PackageUtilService.tabSaveFunction = self.onSave;
                    }
                    $route.updateParams({editView: tabName});
                }
            };

            self.onTabDeselect = function (tabName, event) {
                if (!_.get(PackageUtilService, 'editorForm.$dirty')) {
                    if (tabName === 'metadata') {
                        PackageUtilService.tabSaveFunction = null;
                    }
                    if (PackageUtilService.postCloseUpdate) {
                        PackageUtilService.postCloseUpdate();
                    }
                } else {
                    event.preventDefault();
                    showUnsavedChangesWarning();
                }
            };

            self.onAcceptPackage = function () {
                if (hasWarnings()) {
                    ModalService.showErrorsWarningsModal(
                        self.packageObjectData.validationResult,
                        self.packageObjectData.name,
                        true,
                        self.acceptPackage
                    );
                } else {
                    self.acceptPackage();
                }
            };

            self.acceptPackage = function () {
                self.packageObjectData.acceptStatus = 'ACCEPTED';
                self.loadingIndicator.show = true;
                PackageResourceFactory.acceptPackage({id: $routeParams.id}).$promise.then(function (val) {
                    PackageUtilService.pollForPackageUpdates();
                    self.loadingIndicator.show = false;
                });
            };

            self.onRejectPackage = function () {
                ModalService.showRejectPackageModal(self.packageObjectData.rejectReason, false, true, self.rejectPackage);
            };

            self.rejectPackage = function (rejectReason) {
                self.packageObjectData.acceptStatus = 'REJECTED';
                self.loadingIndicator.show = true;
                PackageResourceFactory.rejectPackage({
                    id: $routeParams.id,
                    reason: rejectReason
                }).$promise.then(function (val) {
                    self.packageObjectData.rejectReason = rejectReason;
                    PackageUtilService.pollForPackageUpdates();
                    self.loadingIndicator.show = false;
                });
            };

            self.clonePackage = function () {
                self.loadingIndicator.show = true;
                PackageResourceFactory.clone({id: $routeParams.id}, {}).$promise.then(function (val) {
                    self.loadingIndicator.show = false;
                });
            };

            self.statusAllowsEdit = function (pkgObject) {
                if (pkgObject) {
                    return PackageUtilService.statusAllowsEdit(pkgObject.status) && !pkgObject.locked &&
                        !pkgObject.isDelivering;
                }
                return PackageUtilService.statusAllowsEdit(self.packageObjectData.status) &&
                    !self.packageObjectData.locked && !self.packageObjectData.isDelivering;
            };

            self.checkErrorWarning = function (field, name) {
                var source = PackageUtilService.errorsAndWarnings()[name];
                return source ? source[field] : null;
            };

            // This listens to server-busy events from all package tabs.
            $scope.$on('server-busy', function (event, options) {
                self.loadingIndicator.show = options.working;
            });

            $scope.$on('$destroy', function () {
                if (self.packageObjectData && self.packageObjectData.$cancelRequest) {
                    self.packageObjectData.$cancelRequest();
                }
                PackageUtilService.cancelPollingInterval();
                NotificationService.clearTimedNotifications();
            });

            getPermissions().then(function (perms) {
                getEditData(perms);
            });

            PackageUtilService.pollForPackageUpdates = pollForPackageUpdates;
        });
